import React, { useContext } from "react";
import { HighlightAlt } from "@mui/icons-material";

import { MapContext } from "../MapProvider";

import { IButtonProps } from "./Toolbar";
import ToolbarToggleButton from "./ToolbarToggleButton";

/**
 * @returns A button that allows the user to select multiple features on the map by drawing a polygon.
 * @description This button uses the `passing_draw_polygon` mode of the `mapbox-gl-draw` library to allow
 * the user to draw a temporary polygon on the map. Once the polygon is drawn, it selects all features that
 * are within or intersecting with the polygon.
 */
const PolygonSelectButton: React.FC<IButtonProps> = () => {
  const { map, drawControl } = useContext(MapContext);

  const handleOnClick = () => {
    drawControl.current?.changeMode("polygon_select");
    map?.fire("draw.modechange", { type: "draw.modechange", mode: "polygon_select" });
  };

  return (
    <ToolbarToggleButton title="Select multiple features" value="polygon_select" onClick={handleOnClick} data-testid="toolbar-polygon-select-button">
      <HighlightAlt />
    </ToolbarToggleButton>
  );
};

export default PolygonSelectButton;
